import { Link } from "react-router-dom";
import { Heart, Users, Fuel, Gauge, Car } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useFavorites } from "@/context/FavoritesContext";

export function CustomerSaved({ favorites, onChange }) {
  const { t } = useTranslation();
  const { toggle } = useFavorites();
  const remove = async (id) => { await toggle(id); onChange?.(); };

  if (!favorites || favorites.length === 0) {
    return (
      <div className="bg-white rounded-2xl border border-slate-200 p-10 text-center" data-testid="saved-empty">
        <span className="grid place-items-center w-14 h-14 rounded-full bg-rose-50 text-rose-400 mx-auto"><Heart size={26} /></span>
        <p className="text-slate-500 mt-4 font-medium">{t("saved.empty")}</p>
        <p className="text-slate-400 text-sm mt-1">{t("saved.emptySub")}</p>
        <Link to="/fleet" className="inline-block mt-6 rounded-full bg-blue-600 text-white px-7 py-3 font-semibold hover:bg-blue-700">{t("saved.browseFleet")}</Link>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="saved-grid">
      {favorites.map((car) => (
        <div key={car.id} data-testid={`saved-car-${car.id}`} className="bg-white rounded-2xl border border-slate-200 overflow-hidden flex flex-col group">
          <div className="aspect-[16/9] bg-slate-100 relative overflow-hidden">
            {car.image_url ? (
              <img src={car.image_url} alt={car.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            ) : (
              <span className="absolute inset-0 grid place-items-center text-slate-300"><Car size={36} /></span>
            )}
            <button onClick={() => remove(car.id)} data-testid={`unsave-${car.id}`} className="absolute top-3 right-3 w-9 h-9 grid place-items-center rounded-full bg-white/90 text-rose-500 shadow hover:bg-white transition-colors">
              <Heart size={17} className="fill-rose-500" />
            </button>
          </div>
          <div className="p-5 flex-1 flex flex-col">
            <p className="label-caps text-blue-600">{car.make}</p>
            <h3 className="font-heading text-lg font-semibold text-slate-900 mt-1">{car.name}</h3>
            <div className="flex items-center gap-4 mt-3 text-slate-500 text-sm">
              <span className="flex items-center gap-1.5"><Users size={14} />{car.seats}</span>
              <span className="flex items-center gap-1.5"><Gauge size={14} />{car.transmission}</span>
              <span className="flex items-center gap-1.5"><Fuel size={14} />{car.fuel}</span>
            </div>
            <div className="mt-auto pt-5 flex items-center justify-between">
              <p className="font-heading text-xl font-bold text-slate-900">${Math.round(car.weekly_rate / 7)}<span className="text-slate-400 text-sm font-normal">{t("saved.perDay")}</span></p>
              <Link to={`/cars/${car.id}`} data-testid={`saved-book-${car.id}`} className="rounded-full bg-blue-600 text-white px-5 py-2 text-sm font-semibold hover:bg-blue-700">{t("saved.book")}</Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
